import PropTypes from 'prop-types';
import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { COOKIE } from '../constants';

const AcceptCookies = ({ onAccept }) => (
  <CookieConsent
    location="bottom"
    buttonText="OK"
    containerClasses="c-acceptcookie"
    buttonClasses="c-acceptcookie__button"
    cookieName={COOKIE}
    style={{ background: '', alignItems: '', justifyContent: '' }}
    buttonStyle={{ background: '', color: '', padding: '' }}
    onAccept={onAccept}
  >
      This website stores cookies on your computer. These cookies are used to
      provide a more personalized experience and to track your whereabouts
      around our website in compliance with the European General Data Protection
      Regulation.
  </CookieConsent>
);
AcceptCookies.propTypes = {
  onAccept: PropTypes.func.isRequired,
};

export default AcceptCookies;



// WEBPACK FOOTER //
// ./src/app/acceptCookies/components/AcceptCookies.jsx